<!--
    Hält die Panels zusammen: standardmässig ist nur eines offen, mit `multiple`
    schaltet jedes für sich. Muster aus aesthetify, hier über provide/inject
    statt über die Slot-Vnodes — so brauchen die Panels keine Refs im Container
    und funktionieren auch einzeln, ohne Container.
-->
<script setup>
import { provide, ref } from "vue";

const props = defineProps({
    multiple: Boolean,
});

const openIds = ref(new Set());

const isOpen = (id) => openIds.value.has(id);

const setOpen = (id, open) => {
    // Neues Set statt mutieren, sonst merkt die Reaktivität die Änderung nicht.
    const next = new Set(props.multiple ? openIds.value : []);

    if (open) {
        next.add(id);
    } else {
        next.delete(id);
    }

    openIds.value = next;
};

provide("accordion", {
    isOpen,
    setOpen,
    toggle: (id) => setOpen(id, !isOpen(id)),
});
</script>

<template>
    <div class="accordion">
        <slot />
    </div>
</template>
